import { h, Fragment } from 'preact'
import { useContext } from 'preact/compat'
import { Query } from '../context'

import { Button } from './Button.jsx'
import { Close } from './Icon.jsx'


export function Search({ onUpdate }) {

	const query = useContext(Query)

	const handler = event => {
		query.set('page', null)
		query.set('lastEdited', 'search')
		query.set(event.currentTarget.name, event.currentTarget.value)
		onUpdate()
	}

	return <>
		<div class="ui-input-overlay ui-input-overlay--block">
			<label class="ui-textinput ui-textinput--large@medium ui-textinput--block" for="search">
				<div class="ui-textinput__wrap">
					<span role="presentation" class="ui-textinput__focus-ring"></span>
					<input 
						autocomplete="off"
						class="ui-textinput__input" 
						type="text" 
						name="search" 
						id="search"
						placeholder="Search for roles like ‘Claims’" 
						value={query.get('search') || ''} 
						onInput={handler} 
					/>
				</div>
			</label>
			<button class="ui-button ui-button--icon ui-button--medium ui-button--fill ui-button--yellow" type="submit">
				<span class="ui-button__focus-ring"></span>
				<span class="ui-button__icon ui-button__icon">
					<svg class="icon-loupe" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12.5274 12.5274C15.2055 9.8493 15.21 5.51171 12.5375 2.83914C9.86489 0.166566 5.5273 0.171069 2.84917 2.84919C0.171048 5.52732 0.166546 9.86491 2.83912 12.5375C5.51169 15.2101 9.84928 15.2055 12.5274 12.5274ZM12.5274 12.5274L17.8492 17.8492" stroke="#1B0D5E" stroke-width="1.5" stroke-linecap="round"></path>
				</svg>
				</span>
			</button>
		</div>
	</>
}